import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import type { LoadState } from "@/lib/queryLoadState";

interface QueryLoadErrorProps {
  failedText: string;
  offlineText: string;
  state: Pick<LoadState, "offline" | "canRetry">;
  query: { isFetching: boolean; refetch: () => unknown };
  className?: string;
}

/**
 * The one failed/offline notice + retry button (#877). The retry rule lives
 * here so the copies can't drift: the button's PRESENCE is gated on
 * `canRetry` (refetch() is inert while paused) and its DISABLED state on
 * `isFetching`. See queryLoadState.ts for why neither alone is enough.
 */
export function QueryLoadError({ failedText, offlineText, state, query, className }: QueryLoadErrorProps) {
  return (
    <div className={className}>
      <p className="text-sm text-muted-foreground">{state.offline ? offlineText : failedText}</p>
      {state.canRetry && (
        <Button
          variant="outline"
          size="sm"
          className="mt-3"
          onClick={() => void query.refetch()}
          disabled={query.isFetching}
        >
          {query.isFetching ? "Trying…" : "Try again"}
        </Button>
      )}
    </div>
  );
}
